var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#EBF2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4438_7290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 11H15C13.6744 11.0016 12.4036 11.5289 11.4662 12.4662C10.5289 13.4036 10.0016 14.6744 10 16V28C10.0016 29.3256 10.5289 30.5964 11.4662 31.5338C12.4036 32.4711 13.6744 32.9984 15 33H29C30.3256 32.9984 31.5964 32.4711 32.5338 31.5338C33.4711 30.5964 33.9984 29.3256 34 28V16C33.9984 14.6744 33.4711 13.4036 32.5338 12.4662C31.5964 11.5289 30.3256 11.0016 29 11ZM15 13H29C29.5988 13.0012 30.1835 13.1815 30.679 13.5178C31.1744 13.8541 31.5579 14.3309 31.78 14.887L24.122 22.546C23.5584 23.1073 22.7954 23.4225 22 23.4225C21.2046 23.4225 20.4416 23.1073 19.878 22.546L12.22 14.887C12.4421 14.3309 12.8256 13.8541 13.321 13.5178C13.8165 13.1815 14.4012 13.0012 15 13ZM29 31H15C14.2044 31 13.4413 30.6839 12.8787 30.1213C12.3161 29.5587 12 28.7956 12 28V17.5L18.464 23.96C19.4026 24.8963 20.6743 25.422 22 25.422C23.3257 25.422 24.5974 24.8963 25.536 23.96L32 17.5V28C32 28.7956 31.6839 29.5587 31.1213 30.1213C30.5587 30.6839 29.7956 31 29 31Z",
    fill: "#314155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4438_7290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/Msg.1b457251.svg";
export { ForwardRef as ReactComponent };